if (location.pathname == "/") {
  const fixedBtn = document.getElementById("fixedBtn");

  const closeBtn = document.getElementById("close-btn")

  closeBtn.addEventListener('click', e => {
    fixedBtn.style.display = "none";
  })
}
